import { render, staticRenderFns } from "./CockpitView.vue?vue&type=template&id=0c0cc575&scoped=true"
import script from "./CockpitView.vue?vue&type=script&lang=ts"
export * from "./CockpitView.vue?vue&type=script&lang=ts"
import style0 from "./CockpitView.vue?vue&type=style&index=0&id=0c0cc575&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0cc575",
  null
  
)

export default component.exports